import React, { useState, useEffect } from "react";
import { ModalOverlayModal, Btns, FormContainer } from "./styled";
import { Modal, Button, Form, Input } from "antd";
import { SaveOutlined } from "@ant-design/icons";
import axios from "axios";
import { toast } from "react-toastify";
import { Method_POST_REST } from "../../../../../../../../service/api";

export function ModalRemoverCredencial({
  isOpen,
  onClose,
  credencialAdicionalId,
  idClient,
  atualizarTelaCredenciais
}) {
  const [loadings, setLoadings] = useState([]);
  const [idCredencial, setIdCredencial] = useState(null);
  const [isIdCliente, setIsItCliente] = useState("");

  useEffect(() => {
    setIdCredencial(credencialAdicionalId);
    setIsItCliente(idClient);
  }, [credencialAdicionalId]);

  const removerCredencial = async () => {
    const url =
      "/cliente/empresa/credencial-acesso/adicional/remover";
    const param = {
      empresa: {
        id: idClient,
      },
      id: idCredencial,
    };

    setLoadings(true);

    try {
      await Method_POST_REST(url, param);
      toast.success("Credencial removida com sucesso!");
      await atualizarTelaCredenciais(idClient);
      onClose();
    } catch (error) {
      console.error("Erro no envio da credencial adicional:", error.message);
    } finally {
      setLoadings(false);
    }
  };

  return (
    <Form.Item>
      <Modal
        title="Confirmação"
        open={isOpen}
        onCancel={() => onClose()}
        footer={[
          <>
            <Btns>
              <Button key="cancel" onClick={() => onClose()}>
                Não
              </Button>
              <Button
                className="btn"
                loading={loadings[0]}
                onClick={removerCredencial}
              >
                Sim
              </Button>
            </Btns>
          </>,
        ]}
      >
        <p>Deseja mesmo remover a credencial adicional?</p>
      </Modal>
    </Form.Item>
  );
}

export default ModalRemoverCredencial;
